module.exports = __webpack_public_path__ + "img/page_bg_onlineDrainage2.856687d5.png";